/**
 * A so-called nara is a discount in quantity. For instance
 * if you buy five packs of a product the sixth pack is free.
 * This class encapsulates the information which
 * "naras" can be displayed in the webshop. It also stores the
 * path to the icon representing a specific nara.
 */
export default class Nara {
  private readonly id: string;

  public get iconUrl(): string {
    return '/images/nara_icons/' + this.id + '.svg';
  }

  private constructor(id: string) {
    this.id = id;
  }

  public static availableNaras = [
    new Nara('5+1'),
    new Nara('10+1'),
    new Nara('11+1'),
    new Nara('12+1'),
    new Nara('15+1'),
    new Nara('20+1'),
    new Nara('33+3')
  ];

  public static findAvailableNaras(naraCodes: string[]): Nara[] {
    return Nara.availableNaras.filter((el) => naraCodes.includes(el.id));
  }

  public static parseNarasJson(localNaras: string): Nara[] {
    if (!localNaras) {
      return [];
    }

    return Nara.findAvailableNaras(JSON.parse(localNaras));
  }
}
